import { useGet } from '../../../sharedModules/hooks/useQuery';
import { BackflowJobGroup } from '../../model';

const BACKFLOW_JOB_GROUPS_URL = '/backflows/backflow_job_groups';

export const defaultBackflowJobGroupFilters = {
  status_in: ['in_progress', 'not_started', 'overdue'],
  company_name_eq: 'all' as const,
  sync_state_in: ['active'],
};

export function useBackflowJobGroups(filterValues: any = defaultBackflowJobGroupFilters) {
  const params = {
    'ransack[backflow_dates_scheduled_date_gteq]': filterValues.backflow_dates_scheduled_date_gteq,
    'ransack[backflow_dates_scheduled_date_lteq]': filterValues.backflow_dates_scheduled_date_lteq,
    'ransack[backflow_dates_scheduled_date_not_null]': 1,
    'ransack[status_in]': filterValues.status_in?.length > 0 ? filterValues.status_in : undefined,
    'ransack[company_name_eq]': filterValues.company_name_eq !== 'all' ? filterValues.company_name_eq : undefined,
    'ransack[sync_state_in]': filterValues.sync_state_in,
  };

  return useGet<{ result: BackflowJobGroup[] }>({ url: BACKFLOW_JOB_GROUPS_URL, params });
}

export const defaultBackflowApprovalQueueFilters = {
  company_name_eq: 'all' as const,
  sync_state_in: ['active'],
};

export function useBackflowApprovalQueue(
  filterValues: any = defaultBackflowApprovalQueueFilters,
  options?: { enabled?: boolean },
) {
  const params = {
    'ransack[backflow_dates_scheduled_date_gteq]': filterValues.backflow_dates_scheduled_date_gteq,
    'ransack[backflow_dates_scheduled_date_lteq]': filterValues.backflow_dates_scheduled_date_lteq,
    'ransack[backflow_dates_scheduled_date_not_null]': 1,
    'ransack[status_eq]': 'pending_approval',
    'ransack[company_name_eq]': filterValues.company_name_eq !== 'all' ? filterValues.company_name_eq : undefined,
    'ransack[sync_state_in]': filterValues.sync_state_in,
  };

  return useGet<{ result: BackflowJobGroup[] }>({ url: BACKFLOW_JOB_GROUPS_URL, params, enabled: options?.enabled });
}

export function useUnscheduledBackflowJobGroups() {
  const params = {
    'ransack[status_in]': ['not_scheduled'],
  };

  return useGet<{ result: BackflowJobGroup[] }>({ url: BACKFLOW_JOB_GROUPS_URL, params });
}
